import { productService } from "@/_services/product/product";
import { documentService } from "@/_services/document/document";
import { downloadSoldCodesCsv } from "@/_services/code/code";
import { downloadBlacklistUserCsv } from "@/_services/blackList/blacklist";
import { jackpotService } from "@/_services/jackpot/jackpot";
import { downloadRefundedPaymentCsv } from "@/_services/transaction/paymentService";

export const exportTypes = {
  sold_documents: {
    label: "Export des ventes de documents",
    fileNamePrefix: "Ventes_de_documents_",
    description: "Cet export contient la liste des documents vendus sur une période spécifique, incluant les produits associés, ainsi que le numéro de commande et l'utilisateur lié à chaque vente.",
    callback: documentService.downloadSoldDocumentCsv,
  },
  sold_products: {
    label: "Export des ventes par produit",
    hasSupplierFilter: true,
    fileNamePrefix: "Ventes_de_produits_",
    description: "Cet export contient la liste des produits vendus sur une période spécifique, avec des informations détaillées telles que le prix d'achat, le taux de TVA, le prix de vente à la date de vente, ainsi que le numéro de commande et l'utilisateur associé à chaque vente. Cette liste peut être filtrée par fournisseur.",
    callback: productService.downloadSoldProductsCsv,
  },
  sold_codes: {
    label: "Export des ventes de codes",
    fileNamePrefix: "ventes_de_codes_",
    description: "Cet export contient la liste des codes vendus sur une période spécifique, incluant les produits associés, ainsi que le numéro de commande et l'utilisateur lié à chaque vente.",
    callback: downloadSoldCodesCsv,
  },
  jackpot_vouchers: {
    label: "Export des ventes Jackpot",
    fileNamePrefix: "export_voucher_jackpot_",
    description: "Cet export contient une liste des voucher Jackpot vendus sur une période spécifique, incluant le voucher, le numéro de commande et les statuts associés. Cet export permet de croiser nos données de commandes avec celles du prestataire.",
    callback: jackpotService.downloadOrderVoucher,
  },
  ogloba_codes: {
    label: "Export des ventes Ogloba",
    fileNamePrefix: "export_codes_ogloba_",
    description: "Cet export contient une liste des codes Ogloba vendus sur une période spécifique, incluant le code, le numéro de commande et les statuts associés. Cet export permet de croiser nos données de commandes avec celles du prestataire.",
    callback: jackpotService.downloadOglobaVoucher,
  },
  payment_refunded: {
    label: "Export des transactions remboursées",
    fileNamePrefix: "Export_remboursements_transactions_",
    description: "Cet export contient la liste des transactions remboursées manuellement par l’admin, leur détail ainsi que les informations liées aux commandes associées.",
    callback: downloadRefundedPaymentCsv,
  }, 
  unavailable_document: {
    label: "Export des documents non disponibles",
    fileNamePrefix: "Documents_non_disponibles_",
    description: "Cet export contient la liste des documents non disponibles sur une période spécifique, incluant les produits associés, ainsi que le numéro de commande et l'utilisateur lié à chaque vente.",
    callback: documentService.downloadUnavailableDocumentCsv,
  }, 
  user_blacklist: {
     label: "Export des utilisateurs blacklistés",
     fileNamePrefix: "user_blacklist_",
     description: "Cet export contient la liste des utilisateurs blacklistés dans un intervalle de temps.",
     callback: downloadBlacklistUserCsv,
 }, 
  search_history: {
     label: "Export de l'historique de la recherche",
     fileNamePrefix: "Export_de_lhistorique_de_la_recherche_",
     description: "Export de l'historique de la recherche",
     callback: productService.downloadSearchHistory,
  }, 
  document_inventory: {
     label: "Export de l’inventaire des stocks de documents",
     fileNamePrefix: "Export_inventaire_documents_",
     description: "Export des l'inventaire des stock de document",
     callback: documentService.downloadDocumentInventoryCsv,
  },
};